import { render } from "./UpdateItemList.vue?vue&type=template&id=0cf53f70"
import script from "./UpdateItemList.vue?vue&type=script&lang=js"
export * from "./UpdateItemList.vue?vue&type=script&lang=js"

import "./UpdateItemList.vue?vue&type=style&index=0&id=0cf53f70&lang=scss"

import exportComponent from "/var/www/html/ran-web/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QFile,QBtn,QInput,QField,QLayout});
